import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Result, Spin, Button } from 'antd';
import IntlMessages from 'util/IntlMessages';
import { useDispatch } from 'react-redux';
import { userSignOut } from 'appRedux/actions/Auth';
import UserService from '@src/services/UserService';

const EmailChangeConfirm = () => {
  const dispatch = useDispatch();
  const userService = new UserService();

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  const history = useHistory();

  const token = new URLSearchParams(location.search).get('token');

  const handleLogout = () => dispatch(userSignOut());

  useEffect(() => {
    if (!token) {
      setError('Token not found');
      setLoading(false);
      return;
    }

    const confirmEmail = async () => {
      setLoading(true);

      try {
        const result = await userService.confirmEmailChange(token);

        if (result?.success) {
          setSuccess(true);
        } else {
          setError(result?.error || 'Error confirming email change');
        }
      } catch (error) {
        setError(error?.message || 'Error processing request');
      }
      finally {
        setLoading(false);
      }
    };

    confirmEmail();
  }, [token]);

  if (loading) {
    return (
      <div className="gx-flex-row gx-justify-content-center gx-pt-4">
        <Spin size="large" />
        <p style={{ marginTop: 20 }}>
          <IntlMessages id="user.email.confirm.processing" />
        </p>
      </div>
    );
  }

  if (success) {
    return (
      <Result
        status="success"
        title={<IntlMessages id="user.email.confirm.success.title" />}
        subTitle={
          <span style={{ fontSize: 18 }}>
            <IntlMessages id="user.email.confirm.success.message" />
          </span>
        }
        extra={[
          <Button type="primary" key="login" onClick={handleLogout}>
            <IntlMessages id="button.login" />
          </Button>,
        ]}
      />
    );
  }

  return (
    <Result
      status="error"
      title={<IntlMessages id="user.email.confirm.error.title" />}
      subTitle={error}
      extra={[
        <Button type="primary" key="back" onClick={() => history.push('/')}>
          <IntlMessages id="button.goBack" />
        </Button>,
      ]}
    />
  );
};

export default EmailChangeConfirm;